import React from "react";
import { useNavigate } from 'react-router-dom';

// ponytail: Improved profile dropdown with user name and avatar placeholder
const User = (props) => {
    const Navigate = useNavigate();
    const userName = localStorage.getItem("user_name") || "Admin";

    const logout = () => {
        localStorage.clear();
        props.setCount(1);
        Navigate('/login');
    }

    return (
        <li className="dropdown notification-list">
            <a className="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-bs-toggle="dropdown" role="button" aria-haspopup="false" style={{ cursor: "pointer" }}>
                <span className="avatar-placeholder">{userName.charAt(0).toUpperCase()}</span>
                <span className="ml-1 user-name-text">{userName}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right profile-dropdown">
                <div className="dropdown-header noti-title">
                    <h6 className="text-overflow m-0">Welcome, {userName}!</h6>
                </div>

                <a className="dropdown-item notify-item">
                    <i className="fe-user"></i>
                    <span>Profile</span>
                </a>

                <a className="dropdown-item notify-item">
                    <i className="fe-settings"></i>
                    <span>Settings</span>
                </a>

                <div className="dropdown-divider"></div>

                <a onClick={logout} className="dropdown-item notify-item">
                    <i className="fe-log-out"></i>
                    <span>Logout</span>
                </a>
            </div>
        </li>
    )
}

export default User;